import { useAppSelector } from '@/Application/Hooks/Redux';
import { useMediaQuery } from '@/modules/perseo-billing/ui/react/src';
import { Button } from '@/modules/perseo-billing/ui/react/src/components/beta';

export const RetryButton = ({ handleClick }: { handleClick: () => void }) => {
  const paymentError = useAppSelector((state) => state?.billing?.paymentError);

  const isMobile = useMediaQuery('xl');

  return (
    <Button
      pl={32}
      pr={32}
      fullWidth={isMobile}
      variant="contained"
      color="primary"
      type="button"
      onClick={handleClick}
    >
      {paymentError?.cta}
    </Button>
  );
};
